import { useState } from "react";
import { PurecloudChat } from "./purecloud_chat";
import { CallbackForm } from "./callback_form";
import { Button } from "../..";
import useSWR from "swr";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var fetcher = args => fetch(args).then(res => res.json());

var checkIfOnline = _ref => {
  var {
    start_time,
    end_time,
    days_online,
    dates_closed
  } = _ref;
  var currentDate = new Date();
  if (!days_online.includes(currentDate.getDay().toString())) return false;
  var startTimeDate = new Date().setHours(+start_time);
  if (startTimeDate >= currentDate.getTime()) return false;
  var endTimeDate = new Date().setHours(+end_time);
  if (endTimeDate <= currentDate.getTime()) return false;
  return dates_closed.every(_ref2 => {
    var {
      date_from,
      date_to
    } = _ref2;
    // Date format: "YYYY-MM-DD TT:TT"
    var dF = date_from.split("-");
    var dT = date_to.split("-");
    var dateFrom = new Date(+dF[0], +dF[1] - 1, +dF[2].replace(" 00:00", ""));
    var dateTo = new Date(+dT[0], +dT[1] - 1, +dT[2].replace(" 00:00", ""));
    return dateFrom > currentDate && currentDate < dateTo;
  });
};

var apiEndpoint = process.env.NEXT_PUBLIC_API_URL || "https://ccq-api.vercel.app";
export var OnlineChat = props => {
  var [acceptedTerms, setAcceptedTerms] = useState(false);
  var [chatIsOnline, setChatIsOnline] = useState(checkIfOnline(props));
  var {
    start_time,
    end_time,
    intro_text,
    chat_name,
    callback_intro_text,
    callback_terms_conditions
  } = props; //Agent status - {online, available}

  var {
    data: agentStatus,
    error
  } = useSWR(apiEndpoint + "/api/v1/purecloud/Y43309d48-01fd-4512-a05f-9adf9df85562/status", fetcher);

  if (error && process.env.NEXT_PUBLIC_VERCEL_ENV === "development") {
    console.error(error);
  }

  return /*#__PURE__*/_jsxs("section", {
    className: "w-full",
    children: [chatIsOnline && /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col md:flex-row rounded shadow max-w-[100vw]",
      children: [!acceptedTerms && /*#__PURE__*/_jsx("div", {
        className: "bg-primary min-h-[100px] md:min-w-[150px] rounded-l justify-center items-center flex",
        children: /*#__PURE__*/_jsx("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 443.5 366.3",
          width: "48px",
          height: "48px",
          className: "fill-[rgb(var(--colors-text-primary))]",
          children: /*#__PURE__*/_jsx("path", {
            d: "M384.9 17.7H56.8c-18 0-32.8 15.2-32.8 33.2v217.7c0 18.2 14.8 32.4 32.8 32.4h49.5l36.5 42c2.1 2.4 5 3.8 8.2 3.8s6.1-1.5 8.2-3.9l36.5-42h189.1c18 0 32.8-14.2 32.8-32.4V50.8c.1-17.9-14.6-33.1-32.7-33.1h0zM124.6 83.3h93v21.9h-93V83.3zm192.5 150.9H124.6v-21.9h192.5v21.9zm0-64.5H124.6v-21.9h192.5v21.9z"
          })
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "grow",
        children: [!acceptedTerms && /*#__PURE__*/_jsxs("div", {
          className: "p-7 md:px-20 md:py-10",
          children: [/*#__PURE__*/_jsx("h3", {
            children: "Chat is online"
          }), (agentStatus == null ? void 0 : agentStatus.available) === false && /*#__PURE__*/_jsxs("div", {
            className: "mb-3",
            children: [/*#__PURE__*/_jsx("p", {
              children: /*#__PURE__*/_jsx("strong", {
                children: "However all online Cancer Support Advisors are currently busy. Please feel free to continue to the chat and wait, or submit a callback request."
              })
            }), /*#__PURE__*/_jsx(Button, {
              onClick: e => {
                e.preventDefault();
                setChatIsOnline(false);
              },
              className: "mb-4",
              color: "primary",
              children: "Submit a callback request here"
            })]
          }), /*#__PURE__*/_jsx("article", {
            children: intro_text
          }), /*#__PURE__*/_jsx(Button, {
            onClick: e => {
              e.preventDefault();
              setAcceptedTerms(true);
            },
            className: "mt-5 whitespace-pre-wrap",
            color: "tertiary",
            children: "I accept and would like to chat"
          })]
        }), acceptedTerms && /*#__PURE__*/_jsx(PurecloudChat, {})]
      })]
    }), !chatIsOnline ? /*#__PURE__*/_jsx("div", {
      className: "rounded shadow p-7 md:px-20 md:py-10",
      children: /*#__PURE__*/_jsx(CallbackForm, {
        chat_name: chat_name,
        callback_intro_text: callback_intro_text,
        callback_terms_conditions: callback_terms_conditions,
        start_time: start_time,
        end_time: end_time
      })
    }) : null]
  });
};
//# sourceMappingURL=index.js.map